export default __webpack_public_path__ + "static/media/logo.28357d5e.svg";